<template>
    <div>
        <!-- <img src="../../assets/img/logo-opacity.png" class="logo-opacity" /> -->
        <img src="../../../static/logo.png" class="logo" />
        <div class="content">
            <p>医院代码</p>
            <Input type="text" placeholder="请输入医院代码" @enter="ChangeHome" @change="HospitalId=arguments[0]"/>

            <div class="ChangeHome" @click="ChangeHome">选择</div>
        </div>
        <div class="copyright">
           <p>Copyright ©2022-{{$format(new Date(),'YYYY')}} </p>
           <p><a target="_blank" href="http://www.huiyxx.com/" style="color:#4c4c4c;">某某公司</a></p>
           <p>All Rights Reserved</p>
           <p>技术支持：189 7920 2829</p>
           <p><a target="_blank" href="https://beian.miit.gov.cn/" style="color:#4c4c4c;">粤ICP备2022052272号-1</a></p>
           <p><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030702004772" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;text-align: center;">
               <img src="../../assets/img//ForTheRecord.png" style="float:left;"/>
               <p style="color:#4c4c4c;float:left;height:20px;line-height:20px; ">粤公网安备 44030702004772号</p>
           </a>
           </p>
        </div>
    </div>
</template>

<script>
    import Input from '@/components/input/input'
    import Field from '../../components/field/field.vue'
    import Box from '@/components/commonBox/commonBox'
    export default {
        name: 'Hospital',
        data() {
            return {
                HospitalId: null
            }
        },
        components: {
            Box,
            Field,
            Input
        },
        mounted() {},
        methods: {
            ChangeHome() {
                debugger
                if (!this.HospitalId) {
                    this.$Toast('请输入医院代码!');
                    return false;
                }
                var _that = this;
                this.$Mui.ajax('http://www.api.huiyxx.com/api/Login/GetHOS', {
                    data: {
                        HOSCODE: _that.HospitalId
                    },
                    dataType: 'json',
                    type: 'get',
                    timeout: 10000,
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                    },
                    beforeSend: function() {
                        _that.$Toast.loading({
                            duration: 0, // 持续展示 toast
                            forbidClick: true,
                            message: '正在加载!'
                        });
                    },
                    processData: true,
                    success: function(data) {
                        if (data.Status) {

                            localStorage.setItem('HospitalUrl', data.Msg); //将Url写入缓存
                            _that.$axios.defaults.baseURL = data.Msg; //赋给http.js中的axios
                            _that.$Toast({
                                message: '验证成功,正在跳转登录页!',
                                duration: 1500,
                                onClose: () => {
                                    _that.$router.push({
                                        name: 'Login'
                                    });
                                }
                            });
                        } else
                            _that.$Toast('请输入正确得医院代码!');
                    },
                    error: function(xhr, type, errorThrown) {
                        _that.$Toast('系统异常,请联系管理员!');

                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .logo-opacity {
        position: absolute;
        top: -280px;
        right: -180px;
        width: 600px;
        height: 600px;
    }

    .logo {
        width: 258px;
        height: 144px;
        margin-top: 129px;
        margin-left: 52px;
    }

    .content {
        margin-top: 38% !important;
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 28px 0 70px !important;
        box-sizing: border-box;

        .items {
            display: flex;
            height: 110px;
            border-bottom: 2px solid #F3F3F3;
            font-size: 29px;
            color: $TEXT-DARK-COLOR;
            align-items: center;

            span {
                &:first-child {
                    flex: 1;
                }
            }

            img {
                width: 32px;
                margin-left: 6px;
            }
            input{
                margin-left: 5% !important;
            }
        }
    }

    .ChangeHome {
        width: 600px;
        height: 100px;
        border-radius: 12px;
        background: $THEME-COLOR;
        line-height: 100px;
        text-align: center;
        font-size: 32px;
        color: $TEXT-LIGHT-COLOR;
        // margin-left: 6%;
        margin-top: 28px;
    }
    .copyright {
        margin-top: 34vw;

        &>p {
            text-align: center;
            color: #4C4C4C;
            font-size: 3vw;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/Hospital/hospital.vue